import axios from 'axios';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const apiVersion = 'v22.0';

const convertionAPI = axios.create({
  baseURL: `https://graph.facebook.com/${apiVersion}/${publicRuntimeConfig.NEXT_PUBLIC_FB_PIXEL}/events?access_token=${publicRuntimeConfig.NEXT_PUBLIC_FB_CONVERTION_TOKEN}`,
  timeout: 3000,
  responseType: 'json',
});

type PageViewFbProps = {
  eventSourceUrl: string;
}

const getFbpCookie = (): string | null => {
  const match = document.cookie.match(/_fbp=([^;]+)/);
  return match ? match[1] : null;
}

const sha256 = async (data: string) => {
  const encoder = new TextEncoder();
  const dataBuffer = encoder.encode(data);
  const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
  return Array.from(new Uint8Array(hashBuffer))
  .map(byte => byte.toString(16).padStart(2, '0'))
  .join('');
};

async function buildUserData() {
  const fbp = getFbpCookie();
  const userAgent = navigator.userAgent;

  try {
    const res = await fetch("https://ipapi.co/json");
    const geo = await res.json();


    return {
      fbp,
      client_user_agent: userAgent,
      client_ip_address: geo.ip,
      country: await sha256(geo.country),
      ct: await sha256(geo.city),
      st: await sha256(geo.region),
      zp: await sha256(geo.postal),
    };
  } catch {
    return {
      fbp,
      client_user_agent: userAgent
    };
  }
}


const sendPageViewEventToFacebookAPI = async ({eventSourceUrl}: PageViewFbProps ) => {
  const payload = [
        {
            "event_name": "ViewContent",
            "event_time": Math.floor(Date.now() / 1000),
            "action_source": "website",
            "event_source_url": eventSourceUrl,
            user_data: await buildUserData(),
        }
      ]
  await convertionAPI.post(`&data=${JSON.stringify(payload)}`);
};

export { sendPageViewEventToFacebookAPI };
